import * as React from 'react'

import { observer } from 'mobx-react'

import MultiFilters from 'modules/core/components/MultiFilters'
import type LogicOperatorForm from 'modules/core/components/MultiFilters/Forms/LogicOperatorForm'
import type MultiFilterForm from 'modules/core/components/MultiFilters/Forms/MultiFilterForm'
import type { FilterOption } from 'modules/core/components/MultiFilters/types'
import type { Attachment } from 'modules/core/components/TetherComponent/types'
import i18n from 'modules/core/lib/i18n'

import DefaultFilters from './_DefaultFilters'
import { EmployeeStatus } from './hooks/utils/employeeStatuses'

interface Props {
  label: string
  attachment?: Attachment
  fields: readonly FilterOption[]
  filters: MultiFilterForm[]
  logicOperator: LogicOperatorForm
  disabled?: boolean
  /**
   * Hides the icon for a more modern look and uses only as much space as necessary
   */
  dense?: boolean
  onAddFilter: () => void
  onRemoveFilter: (index: number) => void
  onApplyFilters: (defaultFilter?: MultiFilterForm[]) => void
  onCancel: () => void
  onResetFilters?: () => void
  setChildPopoverOpen?: (childPopoverOpen: boolean) => void
  showDefaultFilters?: boolean
  filterKey?: string
  filterDependencies?: string[]
  defaultStatusFilter?: EmployeeStatus | null
}

const EmployeeMultiFilters = ({
  label,
  attachment = 'top left',
  fields,
  filters,
  logicOperator,
  disabled,
  dense,
  onAddFilter,
  onRemoveFilter,
  onApplyFilters,
  onCancel,
  onResetFilters,
  setChildPopoverOpen,
  showDefaultFilters,
  filterKey,
  filterDependencies,
  defaultStatusFilter,
}: Props) => {
  if (showDefaultFilters) {
    return (
      <DefaultFilters
        label={label}
        emptyStateLabel={i18n.t('filters.multi_filters.empty_state')}
        attachment={attachment}
        fields={fields}
        filters={filters}
        logicOperator={logicOperator}
        dense={dense}
        onAddFilter={onAddFilter}
        onRemoveFilter={onRemoveFilter}
        onApplyFilters={onApplyFilters}
        onCancel={onCancel}
        onResetFilters={onResetFilters}
        filterKey={filterKey}
        filterDependencies={filterDependencies}
        defaultStatusFilter={defaultStatusFilter}
      />
    )
  }

  return (
    <MultiFilters
      label={label}
      emptyStateLabel={i18n.t('filters.multi_filters.empty_state')}
      attachment={attachment}
      fields={fields}
      filters={filters}
      logicOperator={logicOperator}
      dense={dense}
      onAddFilter={onAddFilter}
      onRemoveFilter={onRemoveFilter}
      onApplyFilters={onApplyFilters}
      onCancel={onCancel}
      setChildPopoverOpen={setChildPopoverOpen}
      disabled={disabled}
    />
  )
}

/**
 * @deprecated This component is deprecated and should not be used in new code. It is considered
 *             to be harmful because it is coupled to the mobx-rest collections. Using this component
 *             will highly impact the performance of your page.
 *             Please, consider using GraphQL instead.
 */
export default observer(EmployeeMultiFilters)
